import React, { createContext, useContext, useReducer, useMemo } from 'react';

// Initial State
const initialState = {
    selectedTab: null, // null = nenhuma aba selecionada inicialmente
    atendSubTab: null, // null = nenhuma sub-aba selecionada inicialmente
    isTabLoading: false,
    counters: {
        'Chat Interno': 0,
        'Atendimentos': 0,
        'Bot': 0,
        'Arquivados': 0,
        'Fila de Espera': 0,
        'Minhas Conversas': 0,
        'Grupos': 0
    }
};

// Actions
const ACTIONS = {
    SET_TAB: 'SET_TAB',
    SET_SUB_TAB: 'SET_SUB_TAB',
    SET_LOADING: 'SET_LOADING',
    UPDATE_COUNTERS: 'UPDATE_COUNTERS',
    RESET: 'RESET'
};

// Reducer
const tabsReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_TAB:
            // ✅ CORREÇÃO: Resetar sub-aba quando mudar para qualquer aba que não seja "Atendimentos"
            // Isso evita que sub-abas de "Atendimentos" sejam usadas em outras abas (ex: "Bot-Fila de Espera")
            // ✅ OTIMIZAÇÃO SEGURA 6: Garantir que sub-aba seja null para abas sem sub-abas
            const shouldResetSubTab = action.payload !== 'Atendimentos' && action.payload !== state.selectedTab;
            return {
                ...state,
                selectedTab: action.payload,
                // Se mudou para aba diferente de "Atendimentos", resetar sub-aba
                // Se mudou para "Atendimentos", também resetar (usuário deve selecionar sub-aba manualmente)
                atendSubTab: (action.payload === 'Atendimentos' || shouldResetSubTab) ? null : state.atendSubTab
            };
        case ACTIONS.SET_SUB_TAB:
            return {
                ...state,
                atendSubTab: action.payload
            };
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                isTabLoading: action.payload
            };
        case ACTIONS.UPDATE_COUNTERS:
            return {
                ...state,
                counters: {
                    ...state.counters,
                    ...action.payload
                }
            };
        case ACTIONS.RESET:
            return initialState;
        default:
            return state;
    }
};

// Context
const WhatsAppTabsContext = createContext(null);

// Provider
export const WhatsAppTabsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(tabsReducer, initialState);

    // ✅ FIX: actions separado do state para ser estável (dispatch nunca muda)
    // ANTES: actions era recriado a cada mudança de state → instabilidade em cascata
    const actions = useMemo(() => ({
        setTab: (tab) => dispatch({ type: ACTIONS.SET_TAB, payload: tab }),
        setSubTab: (subTab) => dispatch({ type: ACTIONS.SET_SUB_TAB, payload: subTab }),
        setLoading: (isLoading) => dispatch({ type: ACTIONS.SET_LOADING, payload: isLoading }),
        updateCounters: (counters) => dispatch({ type: ACTIONS.UPDATE_COUNTERS, payload: counters }),
        reset: () => dispatch({ type: ACTIONS.RESET })
    }), [dispatch]);

    const value = useMemo(() => ({
        state,
        dispatch,
        actions
    }), [state, actions]);

    return (
        <WhatsAppTabsContext.Provider value={value}>
            {children}
        </WhatsAppTabsContext.Provider>
    );
};

// Hook
export const useWhatsAppTabsContext = () => {
    const context = useContext(WhatsAppTabsContext);
    if (!context) {
        throw new Error('useWhatsAppTabsContext must be used within a WhatsAppTabsProvider');
    }
    return context;
};
